/**
|--------------------------------------------------
| featuresv2 permission keys the dashboard gates on
|
| Every `scope:Permission` string the UI checks lives here, so the backend catalog
| (engage-v2-backend `permission_data.json`) has one place to stay in step with. Read them
| through `useFeaturesV2().hasFeature(key)` or a resource's `meta.requiredPermissions`; every
| gate fails closed while the permissions are loading, errored or empty.
|
| A leaf module on purpose: `resources.tsx` (loaded by nearly everything through the
| `@/config` barrel) imports it, so neither the resource table nor a test that stubs a hook
| drags the other in.
|
| Two groups:
| - Org licence flags: emitted from the org's `Account_Setting` (VMD-793 / VMD-794), so they
|   say what the organization has licensed.
| - OrgAdmin catalog permissions (VMD-796): granted to OrgAdmin and not to Practitioner, so
|   `featuresv2` carries them only for org admins. The three marked "new" were added for that
|   ticket as feature-gate placeholders with no resolver; an environment whose seed has not
|   been applied emits none of them and the surface stays hidden for everyone.
|--------------------------------------------------
*/

/**
 * Patient messaging (inbox, patient Messages tab, chat pane): the org licence has patient comms
 * enabled. `useMessengerEnabled` pairs it with the `isMessengerEnabled` environment flag.
 */
export const MESSENGER_PERMISSION = "messenger:UseChat";

/**
 * GDMT titration: the org licence has titration enabled. Org-derived, but read per patient by
 * `useGdmtEnabled` from the patient's own featuresv2.
 */
export const TITRATION_PERMISSION = "titration:UseGdmtTitrate";

/** Organization Settings page and its user-menu entry: `updateAccountRecord`'s permission. */
export const ORG_SETTINGS_PERMISSION = "account:UpdateAccount";

/** Practitioner tab and management page (new, VMD-796). */
export const PRACTITIONER_MANAGEMENT_PERMISSION = "practitioner:ManagePractitioners";

/** Analytics tab and page (new, VMD-796). */
export const ANALYTICS_PERMISSION = "analytics:ViewAnalytics";

/** Patient list: row selection and the bulk "assign to practitioner" action (new, VMD-796). */
export const BULK_ASSIGN_PERMISSION = "careTeam:BulkAssignPractitioner";

/**
 * Broadcast button and modal: `broadcastChatAnnouncement`'s permission. Pairs with the
 * `messenger:UseChat` licence flag (VMD-793); both must be present.
 */
export const BROADCAST_PERMISSION = "messenger:BroadcastChatAnnouncement";
